import axios from 'axios';
import { storeToken } from './userLogin';

/**
 * Check if user is authenticated by calling /me API
 * @returns {Promise<boolean>} True if authenticated, false otherwise
 */
export const checkUserAuth = async () => {
  try {
    const response = await axios.get('/user/me', {
      headers: {
        'Authorization': localStorage.getItem('authToken') ? 
          JSON.parse(localStorage.getItem('authToken')).token : ''
      }
    });
    
    return response.status === 200;
  } catch (error) {
    console.error('Auth check failed:', error);
    return false;
  }
};

/**
 * Handle authentication flow with redirect parameters
 * @param {Function} navigate - React Router navigate function
 * @returns {Promise<void>}
 */
export const handleAuthFlow = async (navigate) => {
  const authToken = localStorage.getItem('authToken');
  
  if (!authToken) {
    // No token, redirect to login
    navigate('/login');
    return;
  }
  
  try {
    // Check if token is valid by calling /me API
    const isAuthenticated = await checkUserAuth();
    
    if (isAuthenticated) {
      // User is authenticated, check for redirect parameters
      const savedParams = localStorage.getItem('redirectParams');
      if (savedParams) {
        const params = JSON.parse(savedParams);
        const redirectUrl = buildRedirectUrl(params.redirectUrl, params);
        localStorage.removeItem('redirectParams'); // Clear saved params
        navigate(redirectUrl);
      } else {
        // No saved params, go to start page
        navigate('/start');
      }
    } else {
      // Token is invalid, clear it and redirect to login
      localStorage.removeItem('authToken');
      navigate('/login');
    }
  } catch (error) {
    console.error('Auth flow error:', error);
    localStorage.removeItem('authToken');
    navigate('/login');
  }
};

/**
 * Build redirect URL with parameters (imported from urlUtils)
 * @param {string} baseUrl - Base URL to redirect to
 * @param {Object} params - Parameters to include
 * @returns {string} Complete redirect URL
 */
const buildRedirectUrl = (baseUrl, params) => {
  const url = new URL(baseUrl, window.location.origin);
  
  if (params.test) {
    url.searchParams.set('test', params.test);
  }
  
  if (params.testseries) {
    url.searchParams.set('testseries', params.testseries);
  }
  
  return url.pathname + url.search;
}; 